import {IAvailability} from '../../types/IAvailability';

export function getSourcesByType(availability: IAvailability[], type: IAvailability['type']): IAvailability[] {
  return availability.filter(s => s.type === type && s.quantity);
}

export function getSourceAvailabilityByType(availability: IAvailability[], type: IAvailability['type']): number {
  return getSourcesByType(availability, type).reduce((qty, source) => qty + getAvailable(source), 0);
}

export function getSourceOnHandByType(availability: IAvailability[], type: IAvailability['type']): number {
  return getSourcesByType(availability, type).reduce((qty, {quantity}) => qty + quantity, 0);
}

export function getLocalSource(availability: IAvailability[]): IAvailability | null {
  return availability.find(s => s.type === 'local') ?? null;
}

export function getAvailable(source: IAvailability): number {
  return Math.max(0, source.quantity - source.committed);
}

export function getFirstMap(availability: IAvailability[]): number | null {
  return availability.find(({map}) => map)?.map ?? null;
}
